import { border, color, rem } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  css`
    :host {
      display: flex;
      flex-direction: column;
      position: relative;
    }

    :where(.select-content) {
      border: ${border(1, 'grey', 300)};
      border-radius: ${rem(4)};
      box-shadow: 0 ${rem(2, 8)} hsl(240 3.8% 46.1% / 0.12);
      margin: unset;
      max-block-size: var(--auto-size-available-height);
      max-inline-size: var(--auto-size-available-width);
      overflow: hidden;
      overflow-y: auto;
      padding: unset;

      ::slotted(a-select-option) {
        inline-size: var(--auto-size-available-width);
      }

      ::slotted(a-select-option:not(:last-child)) {
        border-block-end: ${border(1, 'grey', 300)};
      }
    }

    :where(.select-header) {
      align-items: center;
      background: ${color('white')};
      border: ${border(1, 'neutral', 600)};
      border-radius: ${rem(4)};
      cursor: pointer;
      display: flex;
      gap: ${rem(8)};
      padding: ${rem(12)};
      user-select: none;

      &:hover {
        border-color: ${color('blue', 600)};
      }

      :where(a-icon) {
        color: ${color('blue', 600)};
        flex: 0 0 auto;
        margin-inline-start: auto;
      }
    }

    :where(.select-header.default-text) {
      color: ${color('neutral', 600)};
    }

    :host([disabled]) {
      :where(.select-header) {
        background: ${color('neutral', 100)};
        border: ${border(1, 'neutral', 300)};
        color: ${color('neutral', 400)};
        cursor: not-allowed;

        :where(a-icon) {
          color: ${color('neutral', 400)};
        }
      }

      :where(.container-value img) {
        filter: grayscale(100%);
        opacity: 0.5;
      }
    }

    :where(.container-value) {
      align-items: center;
      display: flex;
      gap: ${rem(20)};
      min-block-size: 1.5em;

      img {
        block-size: ${rem(55)};
        inline-size: ${rem(55)};
        object-fit: contain;

        &:not([src*='http']) {
          display: none;
        }
      }
    }

    :where(.container-value.input-focused) {
      color: ${color('grey', 300)};
    }

    :where(.container-value.input-focused img),
    :where(.container-value.input-focused a-icon) {
      opacity: 0.5;
    }

    :where(input) {
      background: transparent;
      border: unset;
      font-size: inherit;
      outline: none;
      position: absolute;
      transform: translateX(${rem(-3)});
    }

    :where(.container) {
      align-items: center;
      display: flex;
    }

    .hidden {
      visibility: hidden;
    }
  `,
];
